<template>
  <div>
    <div class="fc-text-center">
    	<img class="paystatus_img" src="../assets/img/successIcon.png">
      <p class="paystatus_title">{{$t('m.PayStatusSuccess_title')}}</p>
      <div class="fc-btn-main backhomepage fc-mar-t-super" @click="goHome">{{$t('m.goBack')}}</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
  export default {
    name: 'success',
    data() {
      return {

      }
    },
    watch: {

    },
    filters: {

    },
    mounted() {
       this.getLang();
       Toast.clear();
    },
    methods: {
      getLang() {
        var box = document.getElementById("app");
        let language = navigator.language || navigator.browserLanguage;
        if (language == 'ar') {
          box.style.direction = 'rtl';
        }else{
          box.style.direction = 'ltr';
        }
      },
      goHome(){
      	this.$router.push({
      	  path: '/'
      	})
      }

    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/success.vue